import { get_total_reward } from '@/services/rewards';

const state = {
  totalPoints: 0
};

const getters = {
  totalPoints: (state) => state.totalPoints
};

const mutations = {
  SET_TOTAL_POINTS(state, points) {
    state.totalPoints = points;
  }
};

const actions = {
  async fetchTotalPoints({ commit }) {
    const response = await get_total_reward();
    if (!response.error) {
      const points = response.result.data.total_points || 0;
      commit('SET_TOTAL_POINTS', points);
      return points;
    }
    return 0;
  },
  updateTotalPoints({ commit }, points) {
    commit('SET_TOTAL_POINTS', points);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
